export default function determineStage(initiative) {
  if (!initiative.request) {
    return 'L0';
  }

  if (!initiative.approvalSummary) {
    if (
      initiative.request.requestedStage &&
      initiative.request.requestedStage.startsWith('Submitted for')
    ) {
      return initiative.request.requestedStage;
    }
    return '';
  }

  // First, check for approved stages based on initiative.request.requestedStage
  if (
    initiative.request.requestedStage === 'Submitted for L1 Approval' &&
    initiative.approvalSummary.L1 &&
    initiative.approvalSummary.L1.approvalStatus === 'Approved'
  ) {
    return 'L1';
  } else if (
    initiative.request.requestedStage === 'Submitted for L2 Approval' &&
    initiative.approvalSummary.L2 &&
    initiative.approvalSummary.L2.approvalStatus === 'Approved'
  ) {
    return 'L2';
  } else if (
    initiative.request.requestedStage === 'Submitted for L3 Approval' &&
    initiative.approvalSummary.L3 &&
    initiative.approvalSummary.L3.approvalStatus === 'Approved'
  ) {
    return 'L3';
  } else if (
    initiative.request.requestedStage === 'Submitted for L4 Approval' &&
    initiative.approvalSummary.L4 &&
    initiative.approvalSummary.L4.approvalStatus === 'Approved'
  ) {
    return 'L4';
  } else if (
    initiative.request.requestedStage === 'Submitted for L5 Approval' &&
    initiative.approvalSummary.L5 &&
    initiative.approvalSummary.L5.approvalStatus === 'Approved'
  ) {
    return 'L5';
  }

  // Then, check for pending stages based on initiative.request.requestedStage
  if (
    initiative.request.requestedStage === 'Submitted for L1 Approval' &&
    initiative.approvalSummary.L1 &&
    initiative.approvalSummary.L1.approvalStatus === 'Pending'
  ) {
    return 'Submitted for L1 Approval';
  } else if (
    initiative.request.requestedStage === 'Submitted for L2 Approval' &&
    initiative.approvalSummary.L2 &&
    initiative.approvalSummary.L2.approvalStatus === 'Pending'
  ) {
    return 'Submitted for L2 Approval';
  } else if (
    initiative.request.requestedStage === 'Submitted for L3 Approval' &&
    initiative.approvalSummary.L3 &&
    initiative.approvalSummary.L3.approvalStatus === 'Pending'
  ) {
    return 'Submitted for L3 Approval';
  } else if (
    initiative.request.requestedStage === 'Submitted for L4 Approval' &&
    initiative.approvalSummary.L4 &&
    initiative.approvalSummary.L4.approvalStatus === 'Pending'
  ) {
    return 'Submitted for L4 Approval';
  } else if (
    initiative.request.requestedStage === 'Submitted for L5 Approval' &&
    initiative.approvalSummary.L5 &&
    initiative.approvalSummary.L5.approvalStatus === 'Pending'
  ) {
    return 'Submitted for L5 Approval';
  }

  // Finally, check for approved stages based on initiative.stage
  if (
    initiative.stage &&
    initiative.approvalSummary[initiative.stage] &&
    initiative.approvalSummary[initiative.stage].approvalStatus === 'Approved'
  ) {
    return initiative.stage;
  }

  return '';
}
